import { Box, Button, Typography, Pagination } from "@mui/material";
import React, { useState, useEffect } from "react";

const Recordlist = (props) => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;  // Number of records per page

  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };

  // Paginate the data
  const indexOfLastRecord = currentPage * itemsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - itemsPerPage;
  const currentRecords = props?.data?.slice(indexOfFirstRecord, indexOfLastRecord);

  return (
    <Box>
      {currentRecords?.length > 0 &&
        currentRecords.map((alldata, ind) => {
          return (
            <Box
              key={ind}
              style={{
                margin: 5,
                backgroundColor: "#fff",
                borderRadius: ".5rem",
                marginBottom: "3px",
              }}
            >
              <Box
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: 5,
                  borderBottom: "1px solid #f2f3f5",
                }}
              >
                <Button
                  size="small"
                  style={{
                    background: props.bgcolor,
                    color: "#fff",
                    padding: 5,
                    fontSize: "12px",
                  }}
                >
                  {props.text}
                </Button>
                {/* {alldata.status === 0 ? (
                  <Typography variant="subtitle1" color="red">
                    Pending
                  </Typography>
                ) : ( */}
                  <Typography variant="subtitle1" color="#34be8a">
                    {alldata.status}
                  </Typography>
                {/* )} */}
              </Box>
              <Box style={{ margin: 5 }}>
                <Box style={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography variant="subtitle1" color="#5c4848">
                    {props.by}
                  </Typography>
                  <Typography variant="subtitle1" color="#5c4848">
                    {alldata.upi || alldata.account}
                  </Typography>
                </Box>
                <Box style={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography variant="subtitle1" color="#5c4848">
                    {props.type}
                  </Typography>
                  <Typography variant="body2" color="red">
                    {alldata.recharge || alldata.withdraw}
                  </Typography>
                </Box>
                <Box style={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography variant="subtitle1" color="#5c4848">
                    Time
                  </Typography>
                  <Typography variant="subtitle1" color="#5c4848">
                    {alldata.created_at}
                  </Typography>
                </Box>
                <Box style={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography variant="subtitle1" color="#5c4848">
                    {props.no}
                  </Typography>
                  <Typography variant="subtitle1" color="orange">
                    {alldata.utr || alldata.ifsc}
                    <img
                      width={15}
                      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAALVBMVEUAAACvsMetr8Wqr8KusMavsMeusMarr8OvsMavscelr8WusMausMasr8ausMb/yMBRAAAADnRSTlMAn2Ag77+QQK9/EN/PUG+JKIoAAABzSURBVCjPYyAOrBSEAjEDiMC5dzDgDOazv1aCAo1nYAGmh0ACwcIUKFJ8ClavawARYIWb+BIioOcItVPi3QKwgJwCWDuYNYwEAkUeoQq8exeAKiCkzoBmBgNWgbwmWCTsKwALmMDD9A1EIXMiLCJnERfxAKjSRuHlWJyVAAAAAElFTkSuQmCC"
                      alt=""
                    ></img>
                  </Typography>
                </Box>
              </Box>
            </Box>
          );
        })}
      <Box
        display="flex"
        justifyContent="center"
        style={{ marginTop: "20px", paddingBottom: "20px" }}
      >
        <Pagination
          count={Math.ceil(props?.data?.length / itemsPerPage)} // Calculate total pages
          page={currentPage}
          onChange={handleChangePage}
          variant="outlined"
          shape="rounded"
        />
      </Box>
    </Box>
  );
};

export default Recordlist;
